import { injectBaseConstantMethods } from "./BaseConstants";

export const GOAL_TYPES = {
    PRIMARY: "PRIMARY",
    SECONDARY: "SECONDARY"
};

const displayTextKeys = {
    [GOAL_TYPES.PRIMARY]: "Primary",
    [GOAL_TYPES.SECONDARY]: "Secondary"
};

const labelClass = {
    [GOAL_TYPES.PRIMARY]: "primary",
    [GOAL_TYPES.SECONDARY]: "secondary"
};

export default injectBaseConstantMethods(GOAL_TYPES, displayTextKeys, labelClass);
